import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import UploadIcon from 'icons/Upload.icon';
import { SHEET_FILE_TYPES } from 'data/global';

import './SpreadsheetDropzone.styles.scss';

type SpreadsheetDropzoneProps = {
  className?: string;
  isUploading: boolean;
  onUpload: (file: File) => void;
};

const SpreadsheetDropzone: React.FC<SpreadsheetDropzoneProps> = (props) => {
  const { className, isUploading, onUpload } = props;

  const { t } = useTranslation();

  const onDrop = useCallback(
    ([file]: File[]) => file && onUpload(file),
    [onUpload],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: SHEET_FILE_TYPES,
    maxFiles: 1,
    multiple: false,
    disabled: isUploading,
    onDrop,
  });

  const classes = classNames(
    'spreadsheet-dropzone',
    {
      'spreadsheet-dropzone--drag-active': isDragActive,
      'is-loading': isUploading,
    },
    className,
  );

  return (
    <div {...getRootProps({ className: classes })}>
      <input {...getInputProps()} />

      <UploadIcon className="spreadsheet-dropzone__icon" />
      <p className="spreadsheet-dropzone__title">{t('uploadFile')}</p>
      <p className="spreadsheet-dropzone__note">{t('orDragAndDrop')}</p>
      <p className="spreadsheet-dropzone__note">{t('xlsxOrCsvUpTo10Mb')}</p>
    </div>
  );
};

export default SpreadsheetDropzone;
